import { defineComponent as p, computed as s, openBlock as t, createElementBlock as c, createElementVNode as i, toDisplayString as v, createCommentVNode as b, normalizeStyle as h, normalizeClass as k, createBlock as y, resolveDynamicComponent as w, defineAsyncComponent as _ } from "vue";
const z = (r, e) => {
  const a = r[e];
  return a ? typeof a == "function" ? a() : Promise.resolve(a) : new Promise((m, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(n.bind(null, new Error("Unknown variable dynamic import: " + e)));
  });
}, d = [
  {
    code: "ac",
    fallback: "sh-ac"
  },
  {
    code: "ad",
    name: "Andorra",
    ref: "ad"
  },
  {
    code: "ae",
    name: "United Arab Emirates",
    ref: "ae"
  },
  {
    code: "af-emirate",
    name: "Afghanistan",
    ref: "af-emirate"
  },
  {
    code: "af",
    name: "Afghanistan",
    ref: "af"
  },
  {
    code: "afar",
    name: "Afar",
    ref: "afar"
  },
  {
    code: "ag",
    name: "Antigua and Barbuda",
    ref: "ag"
  },
  {
    code: "ai",
    name: "Anguilla",
    ref: "ai"
  },
  {
    code: "al",
    name: "Albania",
    ref: "al"
  },
  {
    code: "am",
    name: "Armenia",
    ref: "am"
  },
  {
    code: "an",
    name: "Netherlands Antilles",
    ref: "an"
  },
  {
    code: "ao",
    name: "Angola",
    ref: "ao"
  },
  {
    code: "aq-true_south",
    name: "Antarctica",
    ref: "aq-true_south"
  },
  {
    code: "aq",
    name: "Antarctica",
    ref: "aq"
  },
  {
    code: "ar",
    name: "Argentina",
    ref: "ar"
  },
  {
    code: "as",
    name: "American Samoa",
    ref: "as"
  },
  {
    code: "at",
    name: "Austria",
    ref: "at"
  },
  {
    code: "au-aboriginal",
    name: "Australian Aboriginal",
    ref: "au-aboriginal"
  },
  {
    code: "au-act",
    name: "Australian Capital Territory",
    ref: "au-act"
  },
  {
    code: "au-nsw",
    name: "New South Wales",
    ref: "au-nsw"
  },
  {
    code: "au-nt",
    name: "Northern Territory",
    ref: "au-nt"
  },
  {
    code: "au-qld",
    name: "Queensland",
    ref: "au-qld"
  },
  {
    code: "au-sa",
    name: "South Australia",
    ref: "au-sa"
  },
  {
    code: "au-tas",
    name: "Tasmania",
    ref: "au-tas"
  },
  {
    code: "au-vic",
    name: "Victoria",
    ref: "au-vic"
  },
  {
    code: "au-wa",
    name: "Western Australia",
    ref: "au-wa"
  },
  {
    code: "au",
    name: "Australia",
    ref: "au"
  },
  {
    code: "aw",
    name: "Aruba",
    ref: "aw"
  },
  {
    code: "ax",
    name: "Åland Islands",
    ref: "ax"
  },
  {
    code: "az",
    name: "Azerbaijan",
    ref: "az"
  },
  {
    code: "ba",
    name: "Bosnia and Herzegovina",
    ref: "ba"
  },
  {
    code: "bb",
    name: "Barbados",
    ref: "bb"
  },
  {
    code: "bd",
    name: "Bangladesh",
    ref: "bd"
  },
  {
    code: "be",
    name: "Belgium",
    ref: "be"
  },
  {
    code: "bf",
    name: "Burkina Faso",
    ref: "bf"
  },
  {
    code: "bg",
    name: "Bulgaria",
    ref: "bg"
  },
  {
    code: "bh",
    name: "Bahrain",
    ref: "bh"
  },
  {
    code: "bi",
    name: "Burundi",
    ref: "bi"
  },
  {
    code: "bj",
    name: "Benin",
    ref: "bj"
  },
  {
    code: "bl",
    name: "Saint Barthélemy",
    ref: "bl"
  },
  {
    code: "bm",
    name: "Bermuda",
    ref: "bm"
  },
  {
    code: "bn",
    name: "Brunei",
    ref: "bn"
  },
  {
    code: "bo",
    name: "Bolivia",
    ref: "bo"
  },
  {
    code: "bq-bo",
    name: "Bonaire",
    ref: "bq-bo"
  },
  {
    code: "bq-sa",
    name: "Saba",
    ref: "bq-sa"
  },
  {
    code: "bq-se",
    name: "Sint Eustatius",
    ref: "bq-se"
  },
  {
    code: "bq",
    fallback: "bq-bo"
  },
  {
    code: "br",
    name: "Brazil",
    ref: "br"
  },
  {
    code: "bs",
    name: "Bahamas",
    ref: "bs"
  },
  {
    code: "bt",
    name: "Bhutan",
    ref: "bt"
  },
  {
    code: "bv",
    fallback: "no"
  },
  {
    code: "bw",
    name: "Botswana",
    ref: "bw"
  },
  {
    code: "by",
    name: "Belarus",
    ref: "by"
  },
  {
    code: "bz",
    name: "Belize",
    ref: "bz"
  },
  {
    code: "ca-bc",
    name: "British Columbia",
    ref: "ca-bc"
  },
  {
    code: "ca",
    name: "Canada",
    ref: "ca"
  },
  {
    code: "cc",
    name: "Cocos (Keeling) Islands",
    ref: "cc"
  },
  {
    code: "cd",
    name: "Congo, Democratic Republic of the",
    ref: "cd"
  },
  {
    code: "cf",
    name: "Central African Republic",
    ref: "cf"
  },
  {
    code: "cg",
    name: "Congo",
    ref: "cg"
  },
  {
    code: "ch-gr",
    name: "Grisons",
    ref: "ch-gr"
  },
  {
    code: "ch",
    name: "Switzerland",
    ref: "ch"
  },
  {
    code: "ci",
    name: "Ivory Coast",
    ref: "ci"
  },
  {
    code: "ck",
    name: "Cook Islands",
    ref: "ck"
  },
  {
    code: "cl",
    name: "Chile",
    ref: "cl"
  },
  {
    code: "cm",
    name: "Cameroon",
    ref: "cm"
  },
  {
    code: "cn-hk",
    fallback: "hk"
  },
  {
    code: "cn-xj",
    name: "Xinjiang",
    ref: "cn-xj"
  },
  {
    code: "cn",
    name: "China",
    ref: "cn"
  },
  {
    code: "co",
    name: "Colombia",
    ref: "co"
  },
  {
    code: "cp",
    fallback: "fr-cp"
  },
  {
    code: "cq",
    name: "Sark",
    ref: "cq"
  },
  {
    code: "cr",
    name: "Costa Rica",
    ref: "cr"
  },
  {
    code: "cu",
    name: "Cuba",
    ref: "cu"
  },
  {
    code: "cv",
    name: "Cabo Verde",
    ref: "cv"
  },
  {
    code: "cw",
    name: "Curaçao",
    ref: "cw"
  },
  {
    code: "cx",
    name: "Christmas Island",
    ref: "cx"
  },
  {
    code: "cy",
    name: "Cyprus",
    ref: "cy"
  },
  {
    code: "cz",
    name: "Czechia",
    ref: "cz"
  },
  {
    code: "de",
    name: "Germany",
    ref: "de"
  },
  {
    code: "dg",
    fallback: "io"
  },
  {
    code: "dj",
    name: "Djibouti",
    ref: "dj"
  },
  {
    code: "dk",
    name: "Denmark",
    ref: "dk"
  },
  {
    code: "dm",
    name: "Dominica",
    ref: "dm"
  },
  {
    code: "do",
    name: "Dominican Republic",
    ref: "do"
  },
  {
    code: "dz",
    name: "Algeria",
    ref: "dz"
  },
  {
    code: "ea",
    fallback: "es-ce"
  },
  {
    code: "earth",
    name: "Earth",
    ref: "earth"
  },
  {
    code: "easter_island",
    name: "Easter Island",
    ref: "easter_island"
  },
  {
    code: "east_african_federation",
    name: "East African Federation",
    ref: "east_african_federation"
  },
  {
    code: "ec-w",
    name: "Galápagos",
    ref: "ec-w"
  },
  {
    code: "ec",
    name: "Ecuador",
    ref: "ec"
  },
  {
    code: "ee",
    name: "Estonia",
    ref: "ee"
  },
  {
    code: "eg",
    name: "Egypt",
    ref: "eg"
  },
  {
    code: "eh",
    name: "Western Sahara",
    ref: "eh"
  },
  {
    code: "er",
    name: "Eritrea",
    ref: "er"
  },
  {
    code: "es-ar",
    name: "Aragon",
    ref: "es-ar"
  },
  {
    code: "es-ce",
    name: "Ceuta",
    ref: "es-ce"
  },
  {
    code: "es-cn",
    name: "Canary Islands",
    ref: "es-cn"
  },
  {
    code: "es-ct",
    name: "Catalonia",
    ref: "es-ct"
  },
  {
    code: "es-ga",
    name: "Galicia",
    ref: "es-ga"
  },
  {
    code: "es-ib",
    name: "Balearic Islands",
    ref: "es-ib"
  },
  {
    code: "es-ml",
    name: "Melilla",
    ref: "es-ml"
  },
  {
    code: "es-pv",
    name: "Basque Country",
    ref: "es-pv"
  },
  {
    code: "es-variant",
    name: "Spain",
    ref: "es-variant"
  },
  {
    code: "es",
    name: "Spain",
    ref: "es"
  },
  {
    code: "et-or",
    name: "Oromia",
    ref: "et-or"
  },
  {
    code: "et-ti",
    name: "Tigray Region",
    ref: "et-ti"
  },
  {
    code: "et",
    name: "Ethiopia",
    ref: "et"
  },
  {
    code: "eu",
    fallback: "european_union"
  },
  {
    code: "european_union",
    name: "European Union",
    ref: "european_union"
  },
  {
    code: "ewe",
    name: "Ewe",
    ref: "ewe"
  },
  {
    code: "fi",
    name: "Finland",
    ref: "fi"
  },
  {
    code: "fj",
    name: "Fiji",
    ref: "fj"
  },
  {
    code: "fk",
    name: "Falkland Islands (Malvinas)",
    ref: "fk"
  },
  {
    code: "fm",
    name: "Micronesia",
    ref: "fm"
  },
  {
    code: "fo",
    name: "Faroe Islands",
    ref: "fo"
  },
  {
    code: "fr-20r",
    name: "Corsica",
    ref: "fr-20r"
  },
  {
    code: "fr-bre",
    name: "Brittany",
    ref: "fr-bre"
  },
  {
    code: "fr-cp",
    name: "Clipperton Island",
    ref: "fr-cp"
  },
  {
    code: "fr",
    name: "France",
    ref: "fr"
  },
  {
    code: "fx",
    fallback: "fr"
  },
  {
    code: "ga",
    name: "Gabon",
    ref: "ga"
  },
  {
    code: "gb-con",
    name: "Cornwall",
    ref: "gb-con"
  },
  {
    code: "gb-eng",
    name: "England",
    ref: "gb-eng"
  },
  {
    code: "gb-nir",
    name: "Northern Ireland",
    ref: "gb-nir"
  },
  {
    code: "gb-ork",
    name: "Orkney",
    ref: "gb-ork"
  },
  {
    code: "gb-sct",
    name: "Scotland",
    ref: "gb-sct"
  },
  {
    code: "gb-wls",
    name: "Wales",
    ref: "gb-wls"
  },
  {
    code: "gb",
    name: "United Kingdom",
    ref: "gb"
  },
  {
    code: "gd",
    name: "Grenada",
    ref: "gd"
  },
  {
    code: "ge-ab",
    name: "Abkhazia",
    ref: "ge-ab"
  },
  {
    code: "ge",
    name: "Georgia",
    ref: "ge"
  },
  {
    code: "gf",
    name: "French Guiana",
    ref: "gf"
  },
  {
    code: "gg",
    name: "Guernsey",
    ref: "gg"
  },
  {
    code: "gh",
    name: "Ghana",
    ref: "gh"
  },
  {
    code: "gi",
    name: "Gibraltar",
    ref: "gi"
  },
  {
    code: "gl",
    name: "Greenland",
    ref: "gl"
  },
  {
    code: "gm",
    name: "Gambia",
    ref: "gm"
  },
  {
    code: "gn",
    name: "Guinea",
    ref: "gn"
  },
  {
    code: "gp",
    name: "Guadeloupe",
    ref: "gp"
  },
  {
    code: "gq",
    name: "Equatorial Guinea",
    ref: "gq"
  },
  {
    code: "gr",
    name: "Greece",
    ref: "gr"
  },
  {
    code: "gs",
    name: "South Georgia and the South Sandwich Islands",
    ref: "gs"
  },
  {
    code: "gt",
    name: "Guatemala",
    ref: "gt"
  },
  {
    code: "gu",
    name: "Guam",
    ref: "gu"
  },
  {
    code: "guarani",
    name: "Guarani",
    ref: "guarani"
  },
  {
    code: "gw",
    name: "Guinea-Bissau",
    ref: "gw"
  },
  {
    code: "gy",
    name: "Guyana",
    ref: "gy"
  },
  {
    code: "hausa",
    name: "Hausa",
    ref: "hausa"
  },
  {
    code: "hk",
    name: "Hong Kong",
    ref: "hk"
  },
  {
    code: "hm",
    fallback: "au"
  },
  {
    code: "hmong",
    name: "Hmong",
    ref: "hmong"
  },
  {
    code: "hn",
    name: "Honduras",
    ref: "hn"
  },
  {
    code: "hr",
    name: "Croatia",
    ref: "hr"
  },
  {
    code: "ht",
    name: "Haiti",
    ref: "ht"
  },
  {
    code: "hu",
    name: "Hungary",
    ref: "hu"
  },
  {
    code: "ic",
    fallback: "es-cn"
  },
  {
    code: "id-jb",
    name: "West Java",
    ref: "id-jb"
  },
  {
    code: "id-jt",
    name: "Central Java",
    ref: "id-jt"
  },
  {
    code: "id",
    name: "Indonesia",
    ref: "id"
  },
  {
    code: "ie",
    name: "Ireland",
    ref: "ie"
  },
  {
    code: "il",
    name: "Israel",
    ref: "il"
  },
  {
    code: "im",
    name: "Isle of Man",
    ref: "im"
  },
  {
    code: "in-as",
    name: "Assam",
    ref: "in-as"
  },
  {
    code: "in-gj",
    name: "Gujarat",
    ref: "in-gj"
  },
  {
    code: "in-ka",
    name: "Karnataka",
    ref: "in-ka"
  },
  {
    code: "in-mn",
    name: "Manipur",
    ref: "in-mn"
  },
  {
    code: "in-mz",
    name: "Mizoram",
    ref: "in-mz"
  },
  {
    code: "in-or",
    name: "Odisha",
    ref: "in-or"
  },
  {
    code: "in-tg",
    name: "Telangana",
    ref: "in-tg"
  },
  {
    code: "in-tn",
    name: "Tamil Nadu",
    ref: "in-tn"
  },
  {
    code: "in",
    name: "India",
    ref: "in"
  },
  {
    code: "io",
    name: "British Indian Ocean Territory",
    ref: "io"
  },
  {
    code: "iq-kr",
    name: "Kurdistan",
    ref: "iq-kr"
  },
  {
    code: "iq",
    name: "Iraq",
    ref: "iq"
  },
  {
    code: "ir",
    name: "Iran",
    ref: "ir"
  },
  {
    code: "is",
    name: "Iceland",
    ref: "is"
  },
  {
    code: "it-23",
    name: "Aosta Valley",
    ref: "it-23"
  },
  {
    code: "it-82",
    name: "Sicily",
    ref: "it-82"
  },
  {
    code: "it-88",
    name: "Sardinia",
    ref: "it-88"
  },
  {
    code: "it",
    name: "Italy",
    ref: "it"
  },
  {
    code: "je",
    name: "Jersey",
    ref: "je"
  },
  {
    code: "jm",
    name: "Jamaica",
    ref: "jm"
  },
  {
    code: "jo",
    name: "Jordan",
    ref: "jo"
  },
  {
    code: "jp",
    name: "Japan",
    ref: "jp"
  },
  {
    code: "kanuri",
    name: "Kanuri",
    ref: "kanuri"
  },
  {
    code: "ke",
    name: "Kenya",
    ref: "ke"
  },
  {
    code: "kg",
    name: "Kyrgyzstan",
    ref: "kg"
  },
  {
    code: "kh",
    name: "Cambodia",
    ref: "kh"
  },
  {
    code: "ki",
    name: "Kiribati",
    ref: "ki"
  },
  {
    code: "kikuyu",
    name: "Kikuyu",
    ref: "kikuyu"
  },
  {
    code: "km",
    name: "Comoros",
    ref: "km"
  },
  {
    code: "kn",
    name: "Saint Kitts and Nevis",
    ref: "kn"
  },
  {
    code: "kongo",
    name: "Kongo",
    ref: "kongo"
  },
  {
    code: "kp",
    name: "North Korea",
    ref: "kp"
  },
  {
    code: "kr",
    name: "South Korea",
    ref: "kr"
  },
  {
    code: "kw",
    name: "Kuwait",
    ref: "kw"
  },
  {
    code: "ky",
    name: "Cayman Islands",
    ref: "ky"
  },
  {
    code: "kz",
    name: "Kazakhstan",
    ref: "kz"
  },
  {
    code: "la",
    name: "Laos",
    ref: "la"
  },
  {
    code: "lb",
    name: "Lebanon",
    ref: "lb"
  },
  {
    code: "lc",
    name: "Saint Lucia",
    ref: "lc"
  },
  {
    code: "li",
    name: "Liechtenstein",
    ref: "li"
  },
  {
    code: "lk",
    name: "Sri Lanka",
    ref: "lk"
  },
  {
    code: "lr",
    name: "Liberia",
    ref: "lr"
  },
  {
    code: "ls",
    name: "Lesotho",
    ref: "ls"
  },
  {
    code: "lt",
    name: "Lithuania",
    ref: "lt"
  },
  {
    code: "lu",
    name: "Luxembourg",
    ref: "lu"
  },
  {
    code: "lv",
    name: "Latvia",
    ref: "lv"
  },
  {
    code: "ly",
    name: "Libya",
    ref: "ly"
  },
  {
    code: "ma",
    name: "Morocco",
    ref: "ma"
  },
  {
    code: "malayali",
    name: "Malayali",
    ref: "malayali"
  },
  {
    code: "maori",
    name: "Maori",
    ref: "maori"
  },
  {
    code: "mc",
    name: "Monaco",
    ref: "mc"
  },
  {
    code: "md",
    name: "Moldova",
    ref: "md"
  },
  {
    code: "me",
    name: "Montenegro",
    ref: "me"
  },
  {
    code: "mf",
    name: "Saint-Martin",
    ref: "mf"
  },
  {
    code: "mg",
    name: "Madagascar",
    ref: "mg"
  },
  {
    code: "mh",
    name: "Marshall Islands",
    ref: "mh"
  },
  {
    code: "mk",
    name: "North Macedonia",
    ref: "mk"
  },
  {
    code: "ml",
    name: "Mali",
    ref: "ml"
  },
  {
    code: "mm",
    name: "Myanmar",
    ref: "mm"
  },
  {
    code: "mn",
    name: "Mongolia",
    ref: "mn"
  },
  {
    code: "mo",
    name: "Macao",
    ref: "mo"
  },
  {
    code: "mp",
    name: "Northern Mariana Islands",
    ref: "mp"
  },
  {
    code: "mq",
    name: "Martinique",
    ref: "mq"
  },
  {
    code: "mr",
    name: "Mauritania",
    ref: "mr"
  },
  {
    code: "ms",
    name: "Montserrat",
    ref: "ms"
  },
  {
    code: "mt",
    name: "Malta",
    ref: "mt"
  },
  {
    code: "mu",
    name: "Mauritius",
    ref: "mu"
  },
  {
    code: "mv",
    name: "Maldives",
    ref: "mv"
  },
  {
    code: "mw",
    name: "Malawi",
    ref: "mw"
  },
  {
    code: "mx",
    name: "Mexico",
    ref: "mx"
  },
  {
    code: "my",
    name: "Malaysia",
    ref: "my"
  },
  {
    code: "mz",
    name: "Mozambique",
    ref: "mz"
  },
  {
    code: "na",
    name: "Namibia",
    ref: "na"
  },
  {
    code: "nato",
    name: "NATO",
    ref: "nato"
  },
  {
    code: "nc",
    name: "New Caledonia",
    ref: "nc"
  },
  {
    code: "ne",
    name: "Niger",
    ref: "ne"
  },
  {
    code: "nf",
    name: "Norfolk Island",
    ref: "nf"
  },
  {
    code: "ng",
    name: "Nigeria",
    ref: "ng"
  },
  {
    code: "ni",
    name: "Nicaragua",
    ref: "ni"
  },
  {
    code: "nl-fr",
    name: "Friesland",
    ref: "nl-fr"
  },
  {
    code: "nl",
    name: "Netherlands",
    ref: "nl"
  },
  {
    code: "no",
    name: "Norway",
    ref: "no"
  },
  {
    code: "northern_cyprus",
    name: "Northern Cyprus",
    ref: "northern_cyprus"
  },
  {
    code: "np",
    name: "Nepal",
    ref: "np"
  },
  {
    code: "nr",
    name: "Nauru",
    ref: "nr"
  },
  {
    code: "nu",
    name: "Niue",
    ref: "nu"
  },
  {
    code: "nz",
    name: "New Zealand",
    ref: "nz"
  },
  {
    code: "occitania",
    name: "Occitania",
    ref: "occitania"
  },
  {
    code: "olympics",
    name: "Olympics",
    ref: "olympics"
  },
  {
    code: "om",
    name: "Oman",
    ref: "om"
  },
  {
    code: "otomi",
    name: "Otomi",
    ref: "otomi"
  },
  {
    code: "pa",
    name: "Panama",
    ref: "pa"
  },
  {
    code: "pe",
    name: "Peru",
    ref: "pe"
  },
  {
    code: "pf",
    name: "French Polynesia",
    ref: "pf"
  },
  {
    code: "pg",
    name: "Papua New Guinea",
    ref: "pg"
  },
  {
    code: "ph",
    name: "Philippines",
    ref: "ph"
  },
  {
    code: "pk-jk",
    name: "Azad Kashmir",
    ref: "pk-jk"
  },
  {
    code: "pk-sd",
    name: "Sindh",
    ref: "pk-sd"
  },
  {
    code: "pk",
    name: "Pakistan",
    ref: "pk"
  },
  {
    code: "pl",
    name: "Poland",
    ref: "pl"
  },
  {
    code: "pm",
    name: "Saint Pierre and Miquelon",
    ref: "pm"
  },
  {
    code: "pn",
    name: "Pitcairn Islands",
    ref: "pn"
  },
  {
    code: "pr",
    name: "Puerto Rico",
    ref: "pr"
  },
  {
    code: "ps",
    name: "Palestine",
    ref: "ps"
  },
  {
    code: "pt-20",
    name: "Azores",
    ref: "pt-20"
  },
  {
    code: "pt-30",
    name: "Madeira",
    ref: "pt-30"
  },
  {
    code: "pt",
    name: "Portugal",
    ref: "pt"
  },
  {
    code: "pw",
    name: "Palau",
    ref: "pw"
  },
  {
    code: "py",
    name: "Paraguay",
    ref: "py"
  },
  {
    code: "qa",
    name: "Qatar",
    ref: "qa"
  },
  {
    code: "quechua",
    name: "Quechua",
    ref: "quechua"
  },
  {
    code: "re",
    name: "Réunion",
    ref: "re"
  },
  {
    code: "ro",
    name: "Romania",
    ref: "ro"
  },
  {
    code: "rs",
    name: "Serbia",
    ref: "rs"
  },
  {
    code: "ru-ba",
    name: "Bashkortostan",
    ref: "ru-ba"
  },
  {
    code: "ru-ce",
    name: "Chechnya",
    ref: "ru-ce"
  },
  {
    code: "ru-cu",
    name: "Chuvashia",
    ref: "ru-cu"
  },
  {
    code: "ru-da",
    name: "Dagestan",
    ref: "ru-da"
  },
  {
    code: "ru-ko",
    name: "Komi Republic",
    ref: "ru-ko"
  },
  {
    code: "ru-ta",
    name: "Tatarstan",
    ref: "ru-ta"
  },
  {
    code: "ru-ud",
    name: "Udmurtia",
    ref: "ru-ud"
  },
  {
    code: "ru",
    name: "Russia",
    ref: "ru"
  },
  {
    code: "rw",
    name: "Rwanda",
    ref: "rw"
  },
  {
    code: "sa",
    name: "Saudi Arabia",
    ref: "sa"
  },
  {
    code: "sami",
    name: "Sami",
    ref: "sami"
  },
  {
    code: "sb",
    name: "Solomon Islands",
    ref: "sb"
  },
  {
    code: "sc",
    name: "Seychelles",
    ref: "sc"
  },
  {
    code: "sd",
    name: "Sudan",
    ref: "sd"
  },
  {
    code: "se",
    name: "Sweden",
    ref: "se"
  },
  {
    code: "sg",
    name: "Singapore",
    ref: "sg"
  },
  {
    code: "sh-ac",
    name: "Ascension Island",
    ref: "sh-ac"
  },
  {
    code: "sh-hl",
    name: "Saint Helena",
    ref: "sh-hl"
  },
  {
    code: "sh-ta",
    name: "Tristan da Cunha",
    ref: "sh-ta"
  },
  {
    code: "sh",
    fallback: "sh-hl"
  },
  {
    code: "si",
    name: "Slovenia",
    ref: "si"
  },
  {
    code: "sj",
    fallback: "no"
  },
  {
    code: "sk",
    name: "Slovakia",
    ref: "sk"
  },
  {
    code: "sl",
    name: "Sierra Leone",
    ref: "sl"
  },
  {
    code: "sm",
    name: "San Marino",
    ref: "sm"
  },
  {
    code: "sn",
    name: "Senegal",
    ref: "sn"
  },
  {
    code: "so",
    name: "Somalia",
    ref: "so"
  },
  {
    code: "somaliland",
    name: "Somaliland",
    ref: "somaliland"
  },
  {
    code: "south_ossetia",
    name: "South Ossetia",
    ref: "south_ossetia"
  },
  {
    code: "soviet_union",
    name: "Soviet Union",
    ref: "soviet_union"
  },
  {
    code: "sr",
    name: "Suriname",
    ref: "sr"
  },
  {
    code: "ss",
    name: "South Sudan",
    ref: "ss"
  },
  {
    code: "st",
    name: "São Tomé and Príncipe",
    ref: "st"
  },
  {
    code: "su",
    fallback: "soviet_union"
  },
  {
    code: "sv",
    name: "El Salvador",
    ref: "sv"
  },
  {
    code: "sx",
    name: "Sint Maarten",
    ref: "sx"
  },
  {
    code: "sy",
    name: "Syria",
    ref: "sy"
  },
  {
    code: "sz",
    name: "Eswatini",
    ref: "sz"
  },
  {
    code: "ta",
    fallback: "sh-ta"
  },
  {
    code: "tc",
    name: "Turks and Caicos Islands",
    ref: "tc"
  },
  {
    code: "td",
    name: "Chad",
    ref: "td"
  },
  {
    code: "tf",
    name: "French Southern Territories",
    ref: "tf"
  },
  {
    code: "tg",
    name: "Togo",
    ref: "tg"
  },
  {
    code: "th",
    name: "Thailand",
    ref: "th"
  },
  {
    code: "tibet",
    name: "Tibet",
    ref: "tibet"
  },
  {
    code: "tj",
    name: "Tajikistan",
    ref: "tj"
  },
  {
    code: "tk",
    name: "Tokelau",
    ref: "tk"
  },
  {
    code: "tl",
    name: "Timor-Leste",
    ref: "tl"
  },
  {
    code: "tm",
    name: "Turkmenistan",
    ref: "tm"
  },
  {
    code: "tn",
    name: "Tunisia",
    ref: "tn"
  },
  {
    code: "to",
    name: "Tonga",
    ref: "to"
  },
  {
    code: "torres_strait_islands",
    name: "Torres Strait Islands",
    ref: "torres_strait_islands"
  },
  {
    code: "tr",
    name: "Turkey",
    ref: "tr"
  },
  {
    code: "transnistria",
    name: "Transnistria",
    ref: "transnistria"
  },
  {
    code: "tt",
    name: "Trinidad and Tobago",
    ref: "tt"
  },
  {
    code: "tv",
    name: "Tuvalu",
    ref: "tv"
  },
  {
    code: "tw",
    name: "Taiwan",
    ref: "tw"
  },
  {
    code: "tz",
    name: "Tanzania",
    ref: "tz"
  },
  {
    code: "ua",
    name: "Ukraine",
    ref: "ua"
  },
  {
    code: "ug",
    name: "Uganda",
    ref: "ug"
  },
  {
    code: "uk",
    fallback: "gb"
  },
  {
    code: "um",
    fallback: "us"
  },
  {
    code: "un",
    fallback: "united_nations"
  },
  {
    code: "united_nations",
    name: "United Nations",
    ref: "united_nations"
  },
  {
    code: "us-ak",
    name: "Alaska",
    ref: "us-ak"
  },
  {
    code: "us-al",
    name: "Alabama",
    ref: "us-al"
  },
  {
    code: "us-ar",
    name: "Arkansas",
    ref: "us-ar"
  },
  {
    code: "us-az",
    name: "Arizona",
    ref: "us-az"
  },
  {
    code: "us-ca",
    name: "California",
    ref: "us-ca"
  },
  {
    code: "us-co",
    name: "Colorado",
    ref: "us-co"
  },
  {
    code: "us-dc",
    name: "District of Columbia",
    ref: "us-dc"
  },
  {
    code: "us-fl",
    name: "Florida",
    ref: "us-fl"
  },
  {
    code: "us-ga",
    name: "Georgia",
    ref: "us-ga"
  },
  {
    code: "us-hi",
    name: "Hawaii",
    ref: "us-hi"
  },
  {
    code: "us-in",
    name: "Indiana",
    ref: "us-in"
  },
  {
    code: "us-mo",
    name: "Missouri",
    ref: "us-mo"
  },
  {
    code: "us-ms",
    name: "Mississippi",
    ref: "us-ms"
  },
  {
    code: "us-nc",
    name: "North Carolina",
    ref: "us-nc"
  },
  {
    code: "us-nm",
    name: "New Mexico",
    ref: "us-nm"
  },
  {
    code: "us-ri",
    name: "Rhode Island",
    ref: "us-ri"
  },
  {
    code: "us-tn",
    name: "Tennessee",
    ref: "us-tn"
  },
  {
    code: "us-tx",
    name: "Texas",
    ref: "us-tx"
  },
  {
    code: "us",
    name: "United States of America",
    ref: "us"
  },
  {
    code: "uy",
    name: "Uruguay",
    ref: "uy"
  },
  {
    code: "uz",
    name: "Uzbekistan",
    ref: "uz"
  },
  {
    code: "va",
    name: "Holy See (Vatican)",
    ref: "va"
  },
  {
    code: "vc",
    name: "Saint Vincent and the Grenadines",
    ref: "vc"
  },
  {
    code: "ve",
    name: "Venezuela",
    ref: "ve"
  },
  {
    code: "vg",
    name: "Virgin Islands (British)",
    ref: "vg"
  },
  {
    code: "vi",
    name: "Virgin Islands (U.S.)",
    ref: "vi"
  },
  {
    code: "vn",
    name: "Vietnam",
    ref: "vn"
  },
  {
    code: "vu",
    name: "Vanuatu",
    ref: "vu"
  },
  {
    code: "wf",
    name: "Wallis and Futuna",
    ref: "wf"
  },
  {
    code: "wiphala",
    name: "Wiphala",
    ref: "wiphala"
  },
  {
    code: "ws",
    name: "Samoa",
    ref: "ws"
  },
  {
    code: "xk",
    name: "Kosovo",
    ref: "xk"
  },
  {
    code: "xx",
    name: "Placeholder",
    ref: "xx"
  },
  {
    code: "ye",
    name: "Yemen",
    ref: "ye"
  },
  {
    code: "yorubaland",
    name: "Yorubaland",
    ref: "yorubaland"
  },
  {
    code: "yt",
    name: "Mayotte",
    ref: "yt"
  },
  {
    code: "za",
    name: "South Africa",
    ref: "za"
  },
  {
    code: "zm",
    name: "Zambia",
    ref: "zm"
  },
  {
    code: "zw",
    name: "Zimbabwe",
    ref: "zw"
  }
], G = [...d.map((r) => r.code)], g = d.reduce((r, e) => {
  const a = e.fallback;
  let m, n;
  if (a) {
    const f = d.find((o) => o.code === e.fallback);
    m = f.name, n = f.ref;
  } else
    m = e.name, n = e.ref;
  return r[e.code] = {
    name: m,
    ref: n
  }, r;
}, {}), C = ["viewBox"], S = /* @__PURE__ */ i("mask", { id: "1a6738c5-83a1-422a-9b03-ef48b0cbbf8b" }, [
  /* @__PURE__ */ i("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), q = { mask: "url(#1a6738c5-83a1-422a-9b03-ef48b0cbbf8b)" }, j = { key: 0 }, x = /* @__PURE__ */ i("path", {
  fill: "#eee",
  d: "M0 0h512v512H0z"
}, null, -1), A = /* @__PURE__ */ i("circle", {
  cx: "253",
  cy: "380",
  r: "32",
  fill: "#acabb1"
}, null, -1), M = /* @__PURE__ */ i("path", {
  fill: "#acabb1",
  d: "M322.4 135.5c-15.6-13.6-37.4-20.3-65.5-20.3-27.9 0-49.9 7.2-66 21.4a74.9 74.9 0 0 0-24.3 55.4h-.2v12.8H224l.1-9a35.2 35.2 0 0 1 9.3-24.8c5.8-6.1 13.7-9 23.5-9 20.7 0 31 11 31 33.4 0 7.4-2 14.5-6 21.1a124.2 124.2 0 0 1-23.9 26 90.4 90.4 0 0 0-24.8 32.3c-4.5 11-6.8 26.7-6.8 45.2h51l.8-13.1a54 54 0 0 1 17.3-33.9l16.2-15.2a131.4 131.4 0 0 0 26.4-33.2 69.5 69.5 0 0 0 7.6-31.8c-.1-24.7-7.8-43.7-23.3-57.3z"
}, null, -1), N = { fill: "none" }, I = ["r"], u = /* @__PURE__ */ p({
  __name: "xx",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, a = s(() => 512 + 2 * e.strokeWidth), m = s(() => -e.strokeWidth), n = s(() => 256 + e.strokeWidth / 2);
    return (f, o) => (t(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${m.value} ${m.value} ${a.value} ${a.value}`
    }, [
      S,
      i("g", q, [
        e.flagName ? (t(), c("title", j, v(e.flagName), 1)) : b("", !0),
        x,
        A,
        M
      ]),
      i("g", N, [
        i("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, I)
      ])
    ], 8, C));
  }
}), B = /* @__PURE__ */ p({
  __name: "CircleFlags",
  props: {
    country: {},
    showFlagName: { type: Boolean, default: !0 },
    newFlagName: {},
    size: { default: "medium" },
    strokeWidth: {},
    strokeColor: {}
  },
  setup(r) {
    const e = r, a = s(() => {
      var l;
      const o = e.country.toLocaleLowerCase();
      return (l = g[o]) == null ? void 0 : l.ref;
    }), m = s(
      () => {
        var o;
        return e.showFlagName ? e.newFlagName ?? ((o = g[a.value]) == null ? void 0 : o.name) : void 0;
      }
    ), n = () => _({
      loader: () => z(/* @__PURE__ */ Object.assign({ "./flags/ad.vue": () => import("./ad-7a70c1c2.js"), "./flags/ae.vue": () => import("./ae-19a4e35b.js"), "./flags/af-emirate.vue": () => import("./af-emirate-8e648119.js"), "./flags/af.vue": () => import("./af-7e13e61d.js"), "./flags/afar.vue": () => import("./afar-86461f4f.js"), "./flags/ag.vue": () => import("./ag-d0e9f970.js"), "./flags/ai.vue": () => import("./ai-a832c151.js"), "./flags/al.vue": () => import("./al-9e28e0c2.js"), "./flags/am.vue": () => import("./am-5421e49b.js"), "./flags/an.vue": () => import("./an-09ab4c18.js"), "./flags/ao.vue": () => import("./ao-bda7985c.js"), "./flags/aq-true_south.vue": () => import("./aq-true_south-50e31a94.js"), "./flags/aq.vue": () => import("./aq-9ce7ba11.js"), "./flags/ar.vue": () => import("./ar-c2c23060.js"), "./flags/as.vue": () => import("./as-ae21d0e5.js"), "./flags/at.vue": () => import("./at-7a825d96.js"), "./flags/au-aboriginal.vue": () => import("./au-aboriginal-76e881f1.js"), "./flags/au-act.vue": () => import("./au-act-a391eaac.js"), "./flags/au-nsw.vue": () => import("./au-nsw-6d6115b1.js"), "./flags/au-nt.vue": () => import("./au-nt-622939c6.js"), "./flags/au-qld.vue": () => import("./au-qld-6f666951.js"), "./flags/au-sa.vue": () => import("./au-sa-ba00209d.js"), "./flags/au-tas.vue": () => import("./au-tas-4779e940.js"), "./flags/au-vic.vue": () => import("./au-vic-070e3474.js"), "./flags/au-wa.vue": () => import("./au-wa-194ef49a.js"), "./flags/au.vue": () => import("./au-b09c8afa.js"), "./flags/aw.vue": () => import("./aw-c84b7c6c.js"), "./flags/ax.vue": () => import("./ax-c6f18413.js"), "./flags/az.vue": () => import("./az-7ef53db5.js"), "./flags/ba.vue": () => import("./ba-3a4f8c4d.js"), "./flags/bb.vue": () => import("./bb-926c0c7b.js"), "./flags/bd.vue": () => import("./bd-0fc66c88.js"), "./flags/be.vue": () => import("./be-c5417af8.js"), "./flags/bf.vue": () => import("./bf-1331b065.js"), "./flags/bg.vue": () => import("./bg-4ea93af4.js"), "./flags/bh.vue": () => import("./bh-6fdd8d60.js"), "./flags/bi.vue": () => import("./bi-bbe2e3eb.js"), "./flags/bj.vue": () => import("./bj-a3193407.js"), "./flags/bl.vue": () => import("./bl-04fa5652.js"), "./flags/bm.vue": () => import("./bm-e6474f6f.js"), "./flags/bn.vue": () => import("./bn-5b2482e0.js"), "./flags/bo.vue": () => import("./bo-d1da07ce.js"), "./flags/bq-bo.vue": () => import("./bq-bo-ecb94687.js"), "./flags/bq-sa.vue": () => import("./bq-sa-ed0e662b.js"), "./flags/bq-se.vue": () => import("./bq-se-634f0ce8.js"), "./flags/br.vue": () => import("./br-1298d1db.js"), "./flags/bs.vue": () => import("./bs-c92ce61f.js"), "./flags/bt.vue": () => import("./bt-5ff43263.js"), "./flags/bw.vue": () => import("./bw-769df1f1.js"), "./flags/by.vue": () => import("./by-86e42746.js"), "./flags/bz.vue": () => import("./bz-f597cab5.js"), "./flags/ca-bc.vue": () => import("./ca-bc-1f394105.js"), "./flags/ca.vue": () => import("./ca-9dc1ce3f.js"), "./flags/cc.vue": () => import("./cc-c4133f68.js"), "./flags/cd.vue": () => import("./cd-60c60372.js"), "./flags/cf.vue": () => import("./cf-7d8b8e70.js"), "./flags/cg.vue": () => import("./cg-d55cf741.js"), "./flags/ch-gr.vue": () => import("./ch-gr-7451298f.js"), "./flags/ch.vue": () => import("./ch-e3b3f278.js"), "./flags/ci.vue": () => import("./ci-929cbf1d.js"), "./flags/ck.vue": () => import("./ck-7a5cd8cc.js"), "./flags/cl.vue": () => import("./cl-1abc47e8.js"), "./flags/cm.vue": () => import("./cm-a92f33e6.js"), "./flags/cn-xj.vue": () => import("./cn-xj-c12d8e14.js"), "./flags/cn.vue": () => import("./cn-adbdfa16.js"), "./flags/co.vue": () => import("./co-4533f65b.js"), "./flags/cq.vue": () => import("./cq-e8d392a1.js"), "./flags/cr.vue": () => import("./cr-a34722d7.js"), "./flags/cu.vue": () => import("./cu-58f9807e.js"), "./flags/cv.vue": () => import("./cv-587cbe53.js"), "./flags/cw.vue": () => import("./cw-82815cac.js"), "./flags/cx.vue": () => import("./cx-c385705b.js"), "./flags/cy.vue": () => import("./cy-7b10d283.js"), "./flags/cz.vue": () => import("./cz-968fb7e3.js"), "./flags/de.vue": () => import("./de-69ed2d6f.js"), "./flags/dj.vue": () => import("./dj-e68985b7.js"), "./flags/dk.vue": () => import("./dk-2c530e76.js"), "./flags/dm.vue": () => import("./dm-52ee535e.js"), "./flags/do.vue": () => import("./do-9a650286.js"), "./flags/dz.vue": () => import("./dz-708f9fcd.js"), "./flags/earth.vue": () => import("./earth-c02b5653.js"), "./flags/east_african_federation.vue": () => import("./east_african_federation-42040837.js"), "./flags/easter_island.vue": () => import("./easter_island-98c886a4.js"), "./flags/ec-w.vue": () => import("./ec-w-74c8e537.js"), "./flags/ec.vue": () => import("./ec-1bbad3f0.js"), "./flags/ee.vue": () => import("./ee-7869ee2e.js"), "./flags/eg.vue": () => import("./eg-39e98935.js"), "./flags/eh.vue": () => import("./eh-37c3853f.js"), "./flags/er.vue": () => import("./er-a0cad3a3.js"), "./flags/es-ar.vue": () => import("./es-ar-bc72dc21.js"), "./flags/es-ce.vue": () => import("./es-ce-599c965f.js"), "./flags/es-cn.vue": () => import("./es-cn-4a703d8d.js"), "./flags/es-ct.vue": () => import("./es-ct-bf9b1d44.js"), "./flags/es-ga.vue": () => import("./es-ga-081f9fa8.js"), "./flags/es-ib.vue": () => import("./es-ib-108e656f.js"), "./flags/es-ml.vue": () => import("./es-ml-d0bb9f7a.js"), "./flags/es-pv.vue": () => import("./es-pv-cdbd05a3.js"), "./flags/es-variant.vue": () => import("./es-variant-b50eeb92.js"), "./flags/es.vue": () => import("./es-0bebb3cb.js"), "./flags/et-or.vue": () => import("./et-or-c8da61dd.js"), "./flags/et-ti.vue": () => import("./et-ti-f517000e.js"), "./flags/et.vue": () => import("./et-a97b45d2.js"), "./flags/european_union.vue": () => import("./european_union-c96dd31f.js"), "./flags/ewe.vue": () => import("./ewe-c33111e5.js"), "./flags/fi.vue": () => import("./fi-ed282f21.js"), "./flags/fj.vue": () => import("./fj-228bddb6.js"), "./flags/fk.vue": () => import("./fk-0fa76bd1.js"), "./flags/fm.vue": () => import("./fm-3e93ccf3.js"), "./flags/fo.vue": () => import("./fo-bf7f11fb.js"), "./flags/fr-20r.vue": () => import("./fr-20r-3a3d660b.js"), "./flags/fr-bre.vue": () => import("./fr-bre-e4677c49.js"), "./flags/fr-cp.vue": () => import("./fr-cp-78bde53e.js"), "./flags/fr.vue": () => import("./fr-568f0591.js"), "./flags/ga.vue": () => import("./ga-311a845d.js"), "./flags/gb-con.vue": () => import("./gb-con-8c4ca819.js"), "./flags/gb-eng.vue": () => import("./gb-eng-64de8a9f.js"), "./flags/gb-nir.vue": () => import("./gb-nir-a9871fe8.js"), "./flags/gb-ork.vue": () => import("./gb-ork-c4694b37.js"), "./flags/gb-sct.vue": () => import("./gb-sct-6387ad15.js"), "./flags/gb-wls.vue": () => import("./gb-wls-3a4b0eff.js"), "./flags/gb.vue": () => import("./gb-96bcc0c1.js"), "./flags/gd.vue": () => import("./gd-9ff32119.js"), "./flags/ge-ab.vue": () => import("./ge-ab-d8c36b0a.js"), "./flags/ge.vue": () => import("./ge-d3ae8f42.js"), "./flags/gf.vue": () => import("./gf-d190c0aa.js"), "./flags/gg.vue": () => import("./gg-cec62047.js"), "./flags/gh.vue": () => import("./gh-1851e2f7.js"), "./flags/gi.vue": () => import("./gi-1c39ccb5.js"), "./flags/gl.vue": () => import("./gl-f9d1ce5e.js"), "./flags/gm.vue": () => import("./gm-db366708.js"), "./flags/gn.vue": () => import("./gn-9b9f9482.js"), "./flags/gp.vue": () => import("./gp-b4f41de9.js"), "./flags/gq.vue": () => import("./gq-e8306f27.js"), "./flags/gr.vue": () => import("./gr-731ff16f.js"), "./flags/gs.vue": () => import("./gs-18f0811c.js"), "./flags/gt.vue": () => import("./gt-7477c479.js"), "./flags/gu.vue": () => import("./gu-5f306163.js"), "./flags/guarani.vue": () => import("./guarani-72d9381d.js"), "./flags/gw.vue": () => import("./gw-c6155eb7.js"), "./flags/gy.vue": () => import("./gy-3fee4ec1.js"), "./flags/hausa.vue": () => import("./hausa-6ac6763c.js"), "./flags/hk.vue": () => import("./hk-97f30935.js"), "./flags/hmong.vue": () => import("./hmong-caf96f89.js"), "./flags/hn.vue": () => import("./hn-d9f23ce2.js"), "./flags/hr.vue": () => import("./hr-dcc0ccdc.js"), "./flags/ht.vue": () => import("./ht-270a65e3.js"), "./flags/hu.vue": () => import("./hu-15f62c6b.js"), "./flags/id-jb.vue": () => import("./id-jb-043c49fe.js"), "./flags/id-jt.vue": () => import("./id-jt-a2495237.js"), "./flags/id.vue": () => import("./id-eafb8890.js"), "./flags/ie.vue": () => import("./ie-e6fbd104.js"), "./flags/il.vue": () => import("./il-ec435a7f.js"), "./flags/im.vue": () => import("./im-70518788.js"), "./flags/in-as.vue": () => import("./in-as-1d025095.js"), "./flags/in-gj.vue": () => import("./in-gj-72e879da.js"), "./flags/in-ka.vue": () => import("./in-ka-22947488.js"), "./flags/in-mn.vue": () => import("./in-mn-f8a210c7.js"), "./flags/in-mz.vue": () => import("./in-mz-f2d7cb21.js"), "./flags/in-or.vue": () => import("./in-or-7a91cd54.js"), "./flags/in-tg.vue": () => import("./in-tg-abc2de25.js"), "./flags/in-tn.vue": () => import("./in-tn-b8bf50ca.js"), "./flags/in.vue": () => import("./in-bf47379f.js"), "./flags/io.vue": () => import("./io-9caa536d.js"), "./flags/iq-kr.vue": () => import("./iq-kr-6265dd9e.js"), "./flags/iq.vue": () => import("./iq-8d058d09.js"), "./flags/ir.vue": () => import("./ir-c3a578db.js"), "./flags/is.vue": () => import("./is-ea2ab104.js"), "./flags/it-23.vue": () => import("./it-23-9b348cfb.js"), "./flags/it-82.vue": () => import("./it-82-cf0d3d20.js"), "./flags/it-88.vue": () => import("./it-88-793fa5b6.js"), "./flags/it.vue": () => import("./it-664722ea.js"), "./flags/je.vue": () => import("./je-86e02d5a.js"), "./flags/jm.vue": () => import("./jm-8f0d7cb6.js"), "./flags/jo.vue": () => import("./jo-4ea56437.js"), "./flags/jp.vue": () => import("./jp-4af7eaff.js"), "./flags/kanuri.vue": () => import("./kanuri-871b7294.js"), "./flags/ke.vue": () => import("./ke-bb1afc51.js"), "./flags/kg.vue": () => import("./kg-64f443cd.js"), "./flags/kh.vue": () => import("./kh-c316556a.js"), "./flags/ki.vue": () => import("./ki-bffdc276.js"), "./flags/kikuyu.vue": () => import("./kikuyu-89a287ae.js"), "./flags/km.vue": () => import("./km-355c893f.js"), "./flags/kn.vue": () => import("./kn-fb4355d8.js"), "./flags/kongo.vue": () => import("./kongo-a7466d1b.js"), "./flags/kp.vue": () => import("./kp-1c5a10fe.js"), "./flags/kr.vue": () => import("./kr-d7f978a0.js"), "./flags/kw.vue": () => import("./kw-95254b4f.js"), "./flags/ky.vue": () => import("./ky-e2229c9a.js"), "./flags/kz.vue": () => import("./kz-39afe2f1.js"), "./flags/la.vue": () => import("./la-66b8a48e.js"), "./flags/lb.vue": () => import("./lb-f6563e39.js"), "./flags/lc.vue": () => import("./lc-c7e7ad17.js"), "./flags/li.vue": () => import("./li-d32ef730.js"), "./flags/lk.vue": () => import("./lk-ba1ec9f1.js"), "./flags/lr.vue": () => import("./lr-230c06fa.js"), "./flags/ls.vue": () => import("./ls-3995d955.js"), "./flags/lt.vue": () => import("./lt-10f2ebcd.js"), "./flags/lu.vue": () => import("./lu-861670f3.js"), "./flags/lv.vue": () => import("./lv-b1cce0ab.js"), "./flags/ly.vue": () => import("./ly-0afbb19a.js"), "./flags/ma.vue": () => import("./ma-1eda5aae.js"), "./flags/malayali.vue": () => import("./malayali-c199373b.js"), "./flags/maori.vue": () => import("./maori-0ef7bfb5.js"), "./flags/mc.vue": () => import("./mc-7b29124b.js"), "./flags/md.vue": () => import("./md-50793282.js"), "./flags/me.vue": () => import("./me-c654becc.js"), "./flags/mf.vue": () => import("./mf-0d6d8d3d.js"), "./flags/mg.vue": () => import("./mg-a2b58b39.js"), "./flags/mh.vue": () => import("./mh-ad00d16c.js"), "./flags/mk.vue": () => import("./mk-67bff5a4.js"), "./flags/ml.vue": () => import("./ml-5b9d0b6e.js"), "./flags/mm.vue": () => import("./mm-e646b596.js"), "./flags/mn.vue": () => import("./mn-dc1d9645.js"), "./flags/mo.vue": () => import("./mo-e7525ade.js"), "./flags/mp.vue": () => import("./mp-e2cb3cc2.js"), "./flags/mq.vue": () => import("./mq-c451610e.js"), "./flags/mr.vue": () => import("./mr-e04d34c9.js"), "./flags/ms.vue": () => import("./ms-e56ca7e4.js"), "./flags/mt.vue": () => import("./mt-ccb601ac.js"), "./flags/mu.vue": () => import("./mu-da62ca3b.js"), "./flags/mv.vue": () => import("./mv-69727c6d.js"), "./flags/mw.vue": () => import("./mw-1f2ca459.js"), "./flags/mx.vue": () => import("./mx-a55c5f16.js"), "./flags/my.vue": () => import("./my-d73e3360.js"), "./flags/mz.vue": () => import("./mz-d765a527.js"), "./flags/na.vue": () => import("./na-3a320c3d.js"), "./flags/nato.vue": () => import("./nato-8f14ac35.js"), "./flags/nc.vue": () => import("./nc-e7089660.js"), "./flags/ne.vue": () => import("./ne-5481e6fb.js"), "./flags/nf.vue": () => import("./nf-16445066.js"), "./flags/ng.vue": () => import("./ng-1cd9eb87.js"), "./flags/ni.vue": () => import("./ni-83168f42.js"), "./flags/nl-fr.vue": () => import("./nl-fr-a92dc5f3.js"), "./flags/nl.vue": () => import("./nl-6b43d432.js"), "./flags/no.vue": () => import("./no-672776af.js"), "./flags/northern_cyprus.vue": () => import("./northern_cyprus-1b4305f2.js"), "./flags/np.vue": () => import("./np-90cd5744.js"), "./flags/nr.vue": () => import("./nr-f450133a.js"), "./flags/nu.vue": () => import("./nu-60535c58.js"), "./flags/nz.vue": () => import("./nz-2eabc236.js"), "./flags/occitania.vue": () => import("./occitania-392df43c.js"), "./flags/olympics.vue": () => import("./olympics-55fe312f.js"), "./flags/om.vue": () => import("./om-bd656073.js"), "./flags/otomi.vue": () => import("./otomi-81c29448.js"), "./flags/pa.vue": () => import("./pa-87f25291.js"), "./flags/pe.vue": () => import("./pe-d0849fac.js"), "./flags/pf.vue": () => import("./pf-3922e6ba.js"), "./flags/pg.vue": () => import("./pg-8371326f.js"), "./flags/ph.vue": () => import("./ph-2c19ab10.js"), "./flags/pk-jk.vue": () => import("./pk-jk-00aeac14.js"), "./flags/pk-sd.vue": () => import("./pk-sd-b0f29984.js"), "./flags/pk.vue": () => import("./pk-e27ed696.js"), "./flags/pl.vue": () => import("./pl-2a36e972.js"), "./flags/pm.vue": () => import("./pm-755a8519.js"), "./flags/pn.vue": () => import("./pn-eaa42e94.js"), "./flags/pr.vue": () => import("./pr-507bb379.js"), "./flags/ps.vue": () => import("./ps-b1486836.js"), "./flags/pt-20.vue": () => import("./pt-20-e5497088.js"), "./flags/pt-30.vue": () => import("./pt-30-d4502822.js"), "./flags/pt.vue": () => import("./pt-a4859932.js"), "./flags/pw.vue": () => import("./pw-e42319c3.js"), "./flags/py.vue": () => import("./py-8bfd8fcc.js"), "./flags/qa.vue": () => import("./qa-4794b37c.js"), "./flags/quechua.vue": () => import("./quechua-222d86a9.js"), "./flags/re.vue": () => import("./re-9612cef4.js"), "./flags/ro.vue": () => import("./ro-cfc8a3e2.js"), "./flags/rs.vue": () => import("./rs-5ee0da50.js"), "./flags/ru-ba.vue": () => import("./ru-ba-019eb428.js"), "./flags/ru-ce.vue": () => import("./ru-ce-36bfbe41.js"), "./flags/ru-cu.vue": () => import("./ru-cu-250cfba1.js"), "./flags/ru-da.vue": () => import("./ru-da-1388b868.js"), "./flags/ru-ko.vue": () => import("./ru-ko-68b20f95.js"), "./flags/ru-ta.vue": () => import("./ru-ta-e2c8a201.js"), "./flags/ru-ud.vue": () => import("./ru-ud-129a96b8.js"), "./flags/ru.vue": () => import("./ru-339a5d29.js"), "./flags/rw.vue": () => import("./rw-2b4c9e26.js"), "./flags/sa.vue": () => import("./sa-76af8f6e.js"), "./flags/sami.vue": () => import("./sami-1299b828.js"), "./flags/sb.vue": () => import("./sb-544929cf.js"), "./flags/sc.vue": () => import("./sc-f69cb792.js"), "./flags/sd.vue": () => import("./sd-07d0dd40.js"), "./flags/se.vue": () => import("./se-1cb7df1b.js"), "./flags/sg.vue": () => import("./sg-e5c7855e.js"), "./flags/sh-ac.vue": () => import("./sh-ac-593a57c6.js"), "./flags/sh-hl.vue": () => import("./sh-hl-8d59bef2.js"), "./flags/sh-ta.vue": () => import("./sh-ta-08101177.js"), "./flags/si.vue": () => import("./si-35459248.js"), "./flags/sk.vue": () => import("./sk-413cfecb.js"), "./flags/sl.vue": () => import("./sl-2b033f09.js"), "./flags/sm.vue": () => import("./sm-56c37e70.js"), "./flags/sn.vue": () => import("./sn-48ffbcf0.js"), "./flags/so.vue": () => import("./so-7e2c5c44.js"), "./flags/somaliland.vue": () => import("./somaliland-2bab35d1.js"), "./flags/south_ossetia.vue": () => import("./south_ossetia-8a0b5ab1.js"), "./flags/soviet_union.vue": () => import("./soviet_union-22fe1886.js"), "./flags/sr.vue": () => import("./sr-1dbe4317.js"), "./flags/ss.vue": () => import("./ss-fc9bb920.js"), "./flags/st.vue": () => import("./st-1a6b34e8.js"), "./flags/sv.vue": () => import("./sv-f2131343.js"), "./flags/sx.vue": () => import("./sx-ff0bb622.js"), "./flags/sy.vue": () => import("./sy-a4ba77c8.js"), "./flags/sz.vue": () => import("./sz-6897e002.js"), "./flags/tc.vue": () => import("./tc-1a5b992d.js"), "./flags/td.vue": () => import("./td-69db7e58.js"), "./flags/tf.vue": () => import("./tf-00a93e66.js"), "./flags/tg.vue": () => import("./tg-aeda0f85.js"), "./flags/th.vue": () => import("./th-852caead.js"), "./flags/tibet.vue": () => import("./tibet-f5216c2b.js"), "./flags/tj.vue": () => import("./tj-65bf2a49.js"), "./flags/tk.vue": () => import("./tk-38bf686f.js"), "./flags/tl.vue": () => import("./tl-bc8c0a3a.js"), "./flags/tm.vue": () => import("./tm-f6b16891.js"), "./flags/tn.vue": () => import("./tn-2fe3fc67.js"), "./flags/to.vue": () => import("./to-5a22e18f.js"), "./flags/torres_strait_islands.vue": () => import("./torres_strait_islands-1dea883a.js"), "./flags/tr.vue": () => import("./tr-6385b35e.js"), "./flags/transnistria.vue": () => import("./transnistria-33f2052b.js"), "./flags/tt.vue": () => import("./tt-ccf82cb8.js"), "./flags/tv.vue": () => import("./tv-d16a5f96.js"), "./flags/tw.vue": () => import("./tw-eae8c0a7.js"), "./flags/tz.vue": () => import("./tz-f7960329.js"), "./flags/ua.vue": () => import("./ua-4073e811.js"), "./flags/ug.vue": () => import("./ug-3119b8bc.js"), "./flags/united_nations.vue": () => import("./united_nations-de59b51f.js"), "./flags/us-ak.vue": () => import("./us-ak-0cf84022.js"), "./flags/us-al.vue": () => import("./us-al-c85ea60e.js"), "./flags/us-ar.vue": () => import("./us-ar-06ee5adc.js"), "./flags/us-az.vue": () => import("./us-az-96e16ac5.js"), "./flags/us-ca.vue": () => import("./us-ca-d58c4915.js"), "./flags/us-co.vue": () => import("./us-co-954381bf.js"), "./flags/us-dc.vue": () => import("./us-dc-99207ff8.js"), "./flags/us-fl.vue": () => import("./us-fl-4aa4d1da.js"), "./flags/us-ga.vue": () => import("./us-ga-d2ccd706.js"), "./flags/us-hi.vue": () => import("./us-hi-5ec9e738.js"), "./flags/us-in.vue": () => import("./us-in-a1428524.js"), "./flags/us-mo.vue": () => import("./us-mo-fd7e0b56.js"), "./flags/us-ms.vue": () => import("./us-ms-c529a925.js"), "./flags/us-nc.vue": () => import("./us-nc-b2b82ba3.js"), "./flags/us-nm.vue": () => import("./us-nm-90ec826a.js"), "./flags/us-ri.vue": () => import("./us-ri-08de4ea2.js"), "./flags/us-tn.vue": () => import("./us-tn-69fc6457.js"), "./flags/us-tx.vue": () => import("./us-tx-1259de69.js"), "./flags/us.vue": () => import("./us-cf4985c6.js"), "./flags/uy.vue": () => import("./uy-85cfb131.js"), "./flags/uz.vue": () => import("./uz-90fad9f9.js"), "./flags/va.vue": () => import("./va-46e84e83.js"), "./flags/vc.vue": () => import("./vc-20e2abdf.js"), "./flags/ve.vue": () => import("./ve-cb51ee7b.js"), "./flags/vg.vue": () => import("./vg-7e3907d6.js"), "./flags/vi.vue": () => import("./vi-1ddd6d72.js"), "./flags/vn.vue": () => import("./vn-f5218385.js"), "./flags/vu.vue": () => import("./vu-309b6cf4.js"), "./flags/wf.vue": () => import("./wf-28b3574e.js"), "./flags/wiphala.vue": () => import("./wiphala-b0d2ab07.js"), "./flags/ws.vue": () => import("./ws-c3129edc.js"), "./flags/xk.vue": () => import("./xk-0c1aa626.js"), "./flags/xx.vue": () => import("./xx-7916ee9e.js"), "./flags/ye.vue": () => import("./ye-b9886820.js"), "./flags/yorubaland.vue": () => import("./yorubaland-c067f97e.js"), "./flags/yt.vue": () => import("./yt-6fa074f4.js"), "./flags/za.vue": () => import("./za-338afb4c.js"), "./flags/zm.vue": () => import("./zm-f26eaead.js"), "./flags/zw.vue": () => import("./zw-9d9ad178.js") }), `./flags/${a.value}.vue`),
      loadingComponent: u,
      errorComponent: u,
      delay: 200
    }), f = s(() => a.value ? n() : u);
    return (o, l) => (t(), c("div", {
      class: k({
        "circle-flags": !0,
        "circle-flags-small": e.size === "small",
        "circle-flags-medium": e.size === "medium",
        "circle-flags-large": e.size === "large"
      })
    }, [
      (t(), y(w(f.value), {
        strokeWidth: o.strokeWidth,
        strokeColor: o.strokeColor,
        flagName: m.value
      }, null, 8, ["strokeWidth", "strokeColor", "flagName"]))
    ], 2));
  }
});
const F = {
  install: (r) => {
    r.component("CircleFlags", B);
  }
};
export {
  u as _,
  g as a,
  G as c,
  F as m
};
//# sourceMappingURL=main-5453afb6.js.map
